export default "__VITE_ASSET__4955f624__"